export default function AmountIcon() {
  return (
    <svg width='18' height='19' viewBox='0 0 18 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M7.3125 6.6875V9.5M7.3125 6.6875H6.1875M7.3125 6.6875H10.0312C10.8079 6.6875 11.4375 7.3171 11.4375 8.09375C11.4375 8.8704 10.8079 9.5 10.0312 9.5M7.3125 9.5V12.3125M7.3125 9.5H10.0312M7.3125 12.3125H6.1875M7.3125 12.3125H10.0312C10.8079 12.3125 11.4375 11.6829 11.4375 10.9062C11.4375 10.1296 10.8079 9.5 10.0312 9.5M9 5.5625V6.6875M9 12.3125V13.4375M15.9375 9.5C15.9375 13.3315 12.8315 16.4375 9 16.4375C5.16852 16.4375 2.0625 13.3315 2.0625 9.5C2.0625 5.66852 5.16852 2.5625 9 2.5625C12.8315 2.5625 15.9375 5.66852 15.9375 9.5Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
